
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Index from './pages';
import Quienessomos from './pages/quienessomos';
import Services from './pages/services';
import BlogDetail from './pages/blog-detail';
import Login from './pages/login';
// import Signup from './pages/signup';
import ResetPassword from './pages/reset-password';
import Privacy from './pages/privacy';
import Error from './pages/error';
import Contactus from './pages/contactus';
import Paquetes from './pages/paquetes';
import Tecnologia from './pages/tecnologia';
import ServicioDetalle from './pages/servicio-detalle';
import TecnologiaDetalle from './pages/tecnologia-detalle';
import Directorio from './pages/directorio';
import DirectorioDetalle from './pages/directorio-detalle';
import Blog from './pages/blog';
import PaqueteDetalle from './pages/paquete-detalle';
import Laboratorio from './pages/laboratorio';
import Eventos from './pages/eventos';
import EventoDetalle from './pages/evento-detalle';
import Facturacion from './pages/facturacion';
import Alianzaspage from './pages/alianzaspage';
import Resultadosservicios from './pages/resultadosservicios';
import Certificaciones from './pages/certificaciones';
import Eventoregistro from './pages/evento-registro';
import Arandaplus from './pages/arandaplus';
import Dashboard from './pages/dashboard';
import Perfil from './pages/perfil';
import Logout from './pages/logout';
import Arandapluswelcome from './pages/arandapluswelcome';
import Pedidos from './pages/pedidos';
import PedidoDetalle from './pages/pedido-detalle';
import SucursalPuertoInterior from './pages/sucursal-puerto-interior';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/quienessomos" element={<Quienessomos />} />
      <Route path="/laboratorio" element={<Laboratorio />} />
      <Route path="/servicios" element={<Services />} />
      <Route path="/eventos" element={<Eventos />} />
      <Route path="/evento/:slug" element={<EventoDetalle />} />
      <Route path="/registro-evento" element={<Eventoregistro />} />
      <Route path="/registro-evento/:slug/:listingid" element={<Eventoregistro />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog-leer" element={<BlogDetail />} />
      <Route path="/blog-leer/:slug" element={<BlogDetail />} />
      <Route path="/login" element={<Login />} />
      {/* <Route path="/registro" element={<Signup />} /> */}
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/error" element={<Error />} />
      <Route path="*" element={<Error />} />
      <Route path="/contactus" element={<Contactus />} />
      <Route path="/contacto" element={<Contactus />} />
      <Route path="/contacto/:listingid" element={<Contactus />} />
      <Route path="/paquetes" element={<Paquetes />} />
      <Route path="/paquetes/:shortcutTag" element={<Paquetes />} />
      <Route path="/paquete/:slug" element={<PaqueteDetalle />} />
      <Route path="/tecnologia" element={<Tecnologia />} />
      <Route path="/servicio/:slug" element={<ServicioDetalle />} />
      <Route path="/tecnologia-equipamiento/:slug" element={<TecnologiaDetalle />} />
      <Route path="/directorio" element={<Directorio />} />
      <Route path="/directorio/:slug" element={<DirectorioDetalle />} />
      <Route path="/aviso-privacidad" element={<Privacy />} />
      <Route path="/facturacion" element={<Facturacion />} />
      <Route path="/alianzas" element={<Alianzaspage />} />
      <Route path="/servicios-busqueda" element={<Resultadosservicios />} />
      <Route path="/certificaciones" element={<Certificaciones />} />
      <Route path="/programa-beneficios" element={<Arandaplus />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/perfil" element={<Perfil />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/arandaplus" element={<Arandapluswelcome />} />
      <Route path="/pedidos" element={<Pedidos />} />
      <Route path="/pedido/:iden" element={<PedidoDetalle />} />
      <Route path="/sucursales/puerto-interior" element={<SucursalPuertoInterior />} />
    </Routes>
  );
}

export default App;
